module.exports = __webpack_public_path__ + "static/media/logo.5bef6d7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/topo/logo.svg
// module id = 1266
// module chunks = 0